var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68776 1.96109C8.14927 1.38421 8.82925 1 9.6 1H14.4C15.1707 1 15.8507 1.38421 16.3122 1.96109C16.7691 2.53219 17 3.26767 17 4V5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H20V21.2C20 21.6684 19.8193 22.1232 19.4892 22.4628C19.1581 22.8033 18.7029 23 18.2222 23H5.77778C5.29705 23 4.8419 22.8033 4.51081 22.4628C4.18066 22.1232 4 21.6684 4 21.2V7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H7V4C7 3.26767 7.23089 2.53218 7.68776 1.96109ZM6 7V21H18V7H6ZM15 5H9V4C9 3.67146 9.10626 3.38953 9.2495 3.21048C9.38811 3.03722 9.52205 3 9.6 3H14.4C14.4779 3 14.6119 3.03722 14.7505 3.21048C14.8937 3.38953 15 3.67146 15 4V5ZM10 9C10.5523 9 11 9.44772 11 10V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V10C9 9.44772 9.44772 9 10 9ZM14 9C14.5523 9 15 9.44772 15 10V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V10C13 9.44772 13.4477 9 14 9Z",
    fill: "#C7CDD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.cda2c0d140c1c2be7f9dc00543621077.svg";
export { ForwardRef as ReactComponent };